import { LabelType } from '@ariksa/inventory-core/api';

export const contextTypeOptions = [
  { label: 'Label', value: LabelType.Label },
  { label: 'Key values', value: LabelType.KeyValue },
];
